var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { avatarGroupClasses } from '@mui/material/AvatarGroup';
import { alpha } from '@mui/material/styles';
// ----------------------------------------------------------------------
var COLORS = ['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error'];
var colorByName = function (name) {
    var charAt = name.charAt(0).toLowerCase();
    if (['a', 'c', 'f'].includes(charAt))
        return 'primary';
    if (['e', 'd', 'h'].includes(charAt))
        return 'secondary';
    if (['i', 'k', 'l'].includes(charAt))
        return 'info';
    if (['m', 'n', 'p'].includes(charAt))
        return 'success';
    if (['q', 's', 't'].includes(charAt))
        return 'warning';
    if (['v', 'x', 'y'].includes(charAt))
        return 'error';
    return 'default';
};
// ----------------------------------------------------------------------
export function avatar(theme) {
    return {
        MuiAvatar: {
            variants: COLORS.map(function (color) {
                return color === 'default'
                    ? {
                        props: { color: 'default' },
                        style: {
                            color: theme.palette.text.secondary,
                            backgroundColor: alpha(theme.palette.grey[500], 0.24)
                        }
                    }
                    : {
                        props: { color: color },
                        style: {
                            color: theme.palette[color].contrastText,
                            backgroundColor: theme.palette[color].main
                        }
                    };
            }),
            styleOverrides: {
                rounded: {
                    borderRadius: Number(theme.shape.borderRadius) * 1.5
                },
                colorDefault: function (_a) {
                    var ownerState = _a.ownerState;
                    var color = colorByName("".concat(ownerState.alt));
                    return __assign({}, (!!ownerState.alt && __assign({}, (color !== 'default'
                        ? {
                            color: theme.palette[color].contrastText,
                            backgroundColor: theme.palette[color].main
                        }
                        : {
                            color: theme.palette.text.secondary,
                            backgroundColor: alpha(theme.palette.grey[500], 0.24)
                        }))));
                }
            }
        },
        MuiAvatarGroup: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var ownerState = _a.ownerState;
                    return (__assign({ justifyContent: 'flex-end' }, (ownerState.variant === 'compact' && (_b = {
                            width: 40,
                            height: 40,
                            position: 'relative'
                        },
                        _b["& .".concat(avatarGroupClasses.avatar)] = {
                            margin: 0,
                            width: 28,
                            height: 28,
                            position: 'absolute',
                            '&:first-of-type': {
                                left: 0,
                                bottom: 0,
                                zIndex: 9
                            },
                            '&:last-of-type': {
                                top: 0,
                                right: 0
                            }
                        },
                        _b))));
                },
                avatar: {
                    fontSize: 16,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    '&:first-of-type': {
                        fontSize: 12,
                        color: theme.palette.primary.dark,
                        backgroundColor: theme.palette.primary.lighter
                    }
                }
            }
        }
    };
}
